import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exit-page',
  templateUrl: './exit-page.component.html',
  styleUrls: ['./exit-page.component.css']
})
export class ExitPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
